export default __webpack_public_path__ + "static/cookies-min-a9b9f33eca1bd8522f7d68bb35020900.jpeg";